
export {momentProperties,
suppressDeprecationWarnings,
deprecationHandler,
parseTwoDigitYear,
createFromInputFallback,
ISO_8601,
RFC_2822,
updateOffset,
defaultFormat,
defaultFormatUtc,
lang,
langData,
version,
fn,
min,
max,
now,
utc,
unix,
months,
isDate,
locale,
invalid,
duration,
isMoment,
weekdays,
parseZone,
localeData,
isDuration,
monthsShort,
weekdaysMin,
defineLocale,
updateLocale,
locales,
weekdaysShort,
normalizeUnits,
relativeTimeRounding,
relativeTimeThreshold,
calendarFormat,
HTML5_FMT} from '../../frontend-js-dependencies-web/__liferay__/exports/moment.js';
import __x__ from '../../frontend-js-dependencies-web/__liferay__/exports/moment.js';export default __x__;